import { render, staticRenderFns } from "./Individuals.vue?vue&type=template&id=7828f336&scoped=true&"
import script from "./Individuals.vue?vue&type=script&lang=js&"
export * from "./Individuals.vue?vue&type=script&lang=js&"
import style0 from "./Individuals.vue?vue&type=style&index=0&id=7828f336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7828f336",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAvatar,VCol,VContainer,VProgressLinear,VRow,VSkeletonLoader})
